module.exports = __webpack_public_path__ + "img/str_td.70be10bf.jpg";